
































































































import Vue from 'vue';
import { mapState } from 'vuex';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
    SquareEditOutlineIcon,
    ArrowRightIcon,
  },
  computed: {
    ...mapState({
      boardSection: (state: any) => state.boardSections.board_section,
    }),
  },
  async created() {
    let boardSectionId = parseInt(this.$route.params.boardSectionId);
    if (!boardSectionId) boardSectionId = 1; // TODO: redirect to index
    this.$store.dispatch('PULL_BOARD_SECTION', boardSectionId);
  },
});
